module.exports = __webpack_public_path__ + "static/media/sem-contrato.19db793f.png";